var cssInstalledChunks = {};
var cssLoadingUniqueName = "@github-ui/github-ui";
function handleCssComposes(exports, composes) {
	for (var i = 0; i < composes.length; i += 3) {
		var moduleId = composes[i];
		var composeFrom = composes[i + 1];
		var composeVar = composes[i + 2];
		var composedId = __webpack_require__(composeFrom)[composeVar];
		exports[moduleId] = exports[moduleId] + " " + composedId
	}
}
var loadingAttribute = "data-rspack-loading";
var cssLoadStylesheet = (chunkId, url, done, hmr, fetchPriority) => {
	var link,
		needAttach,
		key = "chunk-" + chunkId;
	if (!hmr) {
		var links = document.getElementsByTagName("link");
		for (var i = 0; i < links.length; i++) {
			var l = links[i];
			var href = l.getAttribute("href") || l.href;
			if (href && !href.startsWith(__webpack_require__.p)) {
				href =
					__webpack_require__.p + (href.startsWith("/") ? href.slice(1) : href);
			}
			if (
				l.rel == "stylesheet" &&
				((href && href.startsWith(url)) ||
					l.getAttribute("data-rspack") == cssLoadingUniqueName + ":" + key)
			) {
				link = l;
				break;
			}
		}
		if (!done) return link;
	}
	if (!link) {
		needAttach = true;
		link = document.createElement("link");
if (__webpack_require__.nc) {
  link.setAttribute("nonce", __webpack_require__.nc);
}

link.setAttribute("data-rspack", cssLoadingUniqueName + ":" + key);


link.setAttribute(loadingAttribute, 1);
link.rel = "stylesheet";
link.href = url;

if (link.href.indexOf(window.location.origin + '/') !== 0) {
  link.crossOrigin = 'anonymous';
}


	}
	var onLinkComplete = (prev, event) => {
		link.onerror = link.onload = null;
		link.removeAttribute(loadingAttribute);
		clearTimeout(timeout);
		if (event && event.type != "load" && link.parentNode) link.parentNode.removeChild(link);
		done(event);
		if (prev) return prev(event);
	};
	if (link.getAttribute(loadingAttribute)) {
		var timeout = setTimeout(
			onLinkComplete.bind(null, undefined, { type: "timeout", target: link }),
			120000 
		);
		link.onerror = onLinkComplete.bind(null, link.onerror);
		link.onload = onLinkComplete.bind(null, link.onload);
	} else onLinkComplete(undefined, { type: "load", target: link });
	if (hmr && hmr.getAttribute("fetchpriority")) link.setAttribute("fetchpriority", hmr.getAttribute("fetchpriority"));
	hmr ? document.head.insertBefore(link, hmr) : needAttach && document.head.appendChild(link);
	return link;
};
__webpack_require__.f.css = (chunkId, promises, fetchPriority) => {
	// css chunk loading
	var installedChunkData = __webpack_require__.o(cssInstalledChunks, chunkId)
		? cssInstalledChunks[chunkId]
		: undefined;
	if (installedChunkData !== 0) {
		// 0 means "already installed".

		// a Promise means "currently loading".
		if (installedChunkData) {
			promises.push(installedChunkData[2]);
		} else {
			if (/^(m([0bpz]|0x|1r|1s|4p|a2|ef|ft|hm|j3|ot|qe|qi)|n([037bdimq]|[9cw]5|0k|23|2u|57|jx|ya|ze)|2(7[07y]|57|5k|8|ci|d6|g3|hd|k4|zm)|f([146lmrx]|w[bin]|2j|4t|bm|d3|n7|ob|pr|sl|to|vi)|q([14bw]|4j|g9e|j7|k4|mc|v0|x6)|w([gjs]|a[69v]|0q|1v|57|7i|cf|ry|v4|wb)|z([0mtwy]|51|a9|bi|dw|f4|gc|mu|x5)|o([8nwx]|15|4n|dj|f6|fo|hu|uh|uz|za|zc)|k([3fm]|ya(|a)|1f|1z8|4h|89|q9|r2|zb)|d([5eirz]|30|cm|f6|gb|km|n1|nc|pi|v7)|l([2dt]|3d|9l|b0|cd|h5|iy|n7|u0|ym)|7(2a|2d|5z|86|a2|aj|d|fa|gn|ie|j|uw|w3)|b([3oz]|84|am|kn|sc|vx|xt)|9([3glqz]|1g|65|87|8h|9u|am|be|e6|j2|ls|mq|og|p9)|r([9gj]|02|7a|9b|9f|hk|ku|n6|oo|q7|xd|zx)|0([9dfgj]|1[5kq]|[aip]g|4y|5q|aj|bc|fi|q9|vb|xz)|t([cdjn]|l(3|7|lv)|3a|3w|51|7lm|a6|ah|gm|ii|n9|qs|ue)|i([iko]|r[4iz]|10|4i|4z|5f|99|a2|ap|b6|c0|gs|kr|lw|nj|ns|ua)|x([9dlyz]|2y|4x|bv|gd|hy|jm|mx|po|r2|rh|yc|zc)|h([16x]|a[58o]|4b|4c|cx|g2|j6|t8|up|wz|yz)|j([5ipq]|29|4f|a4|dp|dv|vb|wb|wf)|3([5be]|71|92|c8|fl|j3|r4|vu|wj|zr)|s([37bcglr]|0a|61|d9|ex|he|hs|kd|kj|me|tz|vp)|v([9ns]|k[dhn]|b3|ct|fa|fg|og)|1([19fio]|00|7c|8m|f1|fk|i1|iz|jf|mh|mu|rv|w8|x7)|8([5ehqwx]|1s|2x|53|e8|es|gu|hi|k2|nm|ov|qc|w4)|g(11|9s|x|yb|yf|zt)|p([2dls]|3x|6o|n8|nr|yv)|4([hnrvz]|7[6eh]|17|1h|2a|bi|eg|ft|uu|v5)|a(2|3u|7h|7y|9o|ck|cv|do|eb|fc|ik|k3|rf|u4|w)|5([456nu]|0s|1p|6n|6p|gc|kk|mz|rd|s9)|c([348l]|23|4t|8a|kc|mi|n9)|6([13goqvwy]|3t|8y|96|cd|co|fq|uo|v8|vyp|yb|zy)|u(2l|8d|dt|ey|gm|hn|k|q|u8|w8|wq)|e([5flrtw]|2b|2f|5l|8w|98|ah|av|hk|l9|mz|tk3|vi|vw|wo)|y([8jy]|2q|7n|81|ek|kw|l8))$/.test(chunkId)) {
				// setup Promise in chunk cache
				var promise = new Promise(function (resolve, reject) {
					installedChunkData = cssInstalledChunks[chunkId] = [resolve, reject];
				});
				promises.push((installedChunkData[2] = promise));

				// start chunk loading
				var url = __webpack_require__.p + __webpack_require__.k(chunkId);
				// create error before stack unwound to get useful stacktrace later
				var error = new Error();
				var loadingEnded = function (event) {
					if (__webpack_require__.o(cssInstalledChunks, chunkId)) {
						installedChunkData = cssInstalledChunks[chunkId];
						if (installedChunkData !== 0) cssInstalledChunks[chunkId] = undefined;
						if (installedChunkData) {
							if (event.type !== "load") {
								var errorType = event && event.type;
								var realSrc = event && event.target && event.target.src;
								error.message =
									"Loading css chunk " +
									chunkId +
									" failed.\n(" +
									errorType +
									": " +
									realSrc +
									")";
								error.name = "ChunkLoadError";
								error.type = errorType;
								error.request = realSrc;
								installedChunkData[1](error);
							} else {
								cssInstalledChunks[chunkId] = 0;
								installedChunkData[0]();
							}
						}
					}
				};
				if (typeof document !== 'undefined') {
					cssLoadStylesheet(chunkId, url, loadingEnded, undefined, fetchPriority);
				} else { loadingEnded({ type: 'load' }); }
			} else cssInstalledChunks[chunkId] = 0;
		}
	}
};
